module.exports = __webpack_public_path__ + "static/img/select2.a8ac8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product2/select2.png
// module id = YUcx
// module chunks = 12